import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../http-client/http-client.service";
import { ResponsibleGamingConfigService } from "../responsible-gaming.config";

import { ProductBlock, ProductBlockResponse } from "./product-block.model";

@Injectable({
	providedIn: "root",
})
export class ProductBlockService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: ResponsibleGamingConfigService
	) {}

	get(): Observable<ProductBlock[]> {
		return this.httpClient.get<ProductBlock[]>({
			url: `${this.config.getProductBlockEndpoint()}`,
		});
	}

	update(products: ProductBlock[]): Observable<ProductBlockResponse> {
		return this.httpClient.put<ProductBlockResponse>({
			url: `${this.config.getProductBlockEndpoint()}`,
			data: products,
		});
	}
}
